import { jsx as e } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ e(
  "svg",
  {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5846 6.22269C15.8816 6.51963 15.8816 7.00108 15.5846 7.29805L10.8831 12L15.5846 16.7019C15.8816 16.9989 15.8816 17.4804 15.5846 17.7773C15.2876 18.0743 14.8062 18.0742 14.5092 17.7773L9.51744 12.785C9.08403 12.3518 9.08354 11.6487 9.51695 11.2155L14.5092 6.22274C14.8062 5.92577 15.2876 5.92575 15.5846 6.22269Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  t as SmallChevronLeft
};
//# sourceMappingURL=SmallChevronLeft.js.map
